import { useState } from 'react';
import { useQuery as useQueryString } from '@/common/hooks/useQuery';
import { useQuerySRMRunners } from '@/api/tradeManager/srm/srm.hooks';

export const useSRMRunners = () => {
  const q = useQueryString();
  const id = q.get('id');
  const checkId = id || '';
  const limit = 20;

  const [pageIndex, setPageIndex] = useState(0);
  const [offset, setOffset] = useState('');
  const [offsetHistory] = useState<string[]>([]);

  const shouldRefetch = pageIndex === 0;

  const { data, isLoading } = useQuerySRMRunners({
    params: {
      offset,
      limit,
      race_id: checkId,
    },
    options: {
      refetchInterval: shouldRefetch ? 60000 : 0, // polling every minute on first page only
      staleTime: shouldRefetch ? 0 : 60 * 5000,
    },
  });

  const next = () => {
    if (!data) return;
    setOffset(data.paging?.next_offset ?? '');
    setPageIndex((prevIdx) => ++prevIdx);
  };
  const previous = () => {
    if (pageIndex === 0) return;
    setOffset(offsetHistory[pageIndex]);
    setPageIndex((prevIdx) => --prevIdx);
  };

  return {
    data,
    isLoading,
    next,
    previous,
    previousDisabled: pageIndex === 0,
    nextDisabled: data?.paging?.next_offset === null,
    hidePagination: pageIndex === 0 && data?.paging?.next_offset === null,
  };
};
